if (!customElements.get('veneera-popup')) {
  customElements.define(
    'veneera-popup',
    class VeneeraPopup extends HTMLElement {
      constructor() {
        super();
        this.details = this.querySelector('details');
        this.closes = this.querySelectorAll('[data-close]');

        // Toggle scroll behavior when details open/close
        this.details.addEventListener('toggle', () => {
          if (this.details.open) {
            document.body.style.overflow = 'hidden'; // Disable scroll
          } else {
            document.body.style.overflow = ''; // Enable scroll
          }
        });

        // Close the popup
        this.closes.forEach(closeBtn => {
          closeBtn.addEventListener('click', () => {
            this.details.open = false;
            if (window.Calendly && typeof Calendly.closePopupWidget === 'function') {
              Calendly.closePopupWidget();
            }
          });
        });
      }
    }
  );
}
